export interface Coordinates {
  lat: number;
  lng: number;
}

const numeric = (value: unknown): number | undefined =>
  typeof value === 'number' && !Number.isNaN(value) ? value : undefined;

export const resolveWellCoordinates = (well: any): Coordinates | null => {
  if (!well) {
    return null;
  }

  const lat =
    numeric(well?.latitude) ??
    numeric(well?.lat) ??
    numeric(well?.coordinates?.lat) ??
    numeric(well?.location?.coordinates?.lat) ??
    numeric(well?.location?.lat) ??
    numeric(well?.geo?.lat) ??
    numeric(well?.geoLocation?.lat);

  const lng =
    numeric(well?.longitude) ??
    numeric(well?.lng) ??
    numeric(well?.lon) ??
    numeric(well?.coordinates?.lng) ??
    numeric(well?.coordinates?.lon) ??
    numeric(well?.location?.coordinates?.lng) ??
    numeric(well?.location?.coordinates?.lon) ??
    numeric(well?.location?.lng) ??
    numeric(well?.location?.lon) ??
    numeric(well?.geo?.lng) ??
    numeric(well?.geo?.lon) ??
    numeric(well?.geoLocation?.lng) ??
    numeric(well?.geoLocation?.lon);

  if (lat === undefined || lng === undefined) {
    return null;
  }

  return { lat, lng };
};
